import React,{useState} from 'react'

function DropDownBox(props) {
    const [dropOpen , setDropOpen] = useState(false)
  return (
    <div
      className={`dropdown-box container my-3`}
      onClick={() => {
        setDropOpen((prev) => {
          return !prev;
        });
      }}
    >
      <div className="box-head d-flex align-items-center justify-content-between gap-3">
        <h5 className="title font-noto mb-0" style={dropOpen ? {color:"#155A75"}:{color:"white"}}>{props.title}</h5>
        <img alt='dropdown icon' src={dropOpen ? '/images/icons/dropdown-add.svg':'/images/icons/dropdown-add.svg'} style={dropOpen ? {transform:"rotate(180deg)"}:{transform:"rotate(0deg)"}} className='eye-icon'/>
      </div>
      <div className="box-content my-4" style={dropOpen?{animation:"bottomBoxOpen .6s ease-in-out",display:"block"}:{display:"none"}}>
          <p className='body-paragraph mb-0 text-start'>{props.content}</p>
      </div>
    </div>
  );
}

export default DropDownBox